import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { ReferralType } from '@principle-theorem/principle-core/interfaces';

interface IReferralTypeDisplay {
  icon: string;
  label: string;
  backgroundColour: string;
}

@Component({
  selector: 'pr-referral-type-chip',
  imports: [NgCommonModule, MatIconModule],
  templateUrl: './referral-type-chip.component.html',
  styleUrl: './referral-type-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralTypeChipComponent {
  private readonly typeConfig: Record<ReferralType, IReferralTypeDisplay> = {
    [ReferralType.Outgoing]: {
      icon: 'call_made',
      label: 'Outgoing',
      backgroundColour: 'bg-amber-200',
    },
    [ReferralType.Incoming]: {
      icon: 'call_received',
      label: 'Incoming',
      backgroundColour: 'bg-purple-200',
    },
  };

  type = input.required<ReferralType>();
  typeInfo = computed((): IReferralTypeDisplay => this.typeConfig[this.type()]);
}
